import React, { forwardRef } from 'react';
import NavigationStepper, {
	NavigationStepperProps,
	NavigationStepperRef,
} from '../NavigationStepper';
import SubTabNavigationStepperItems from './SubTabNavigationStepperItems';

const SubTabNavigationStepper = forwardRef<
	NavigationStepperRef,
	NavigationStepperProps
>((props, ref) => {
	return (
		<NavigationStepper
			{...props}
			ref={ref}
			renderItems={({ items, activeKey, onChange }) => (
				<SubTabNavigationStepperItems
					items={items}
					activeKey={activeKey}
					onChange={onChange}
				/>
			)}
		/>
	);
});

SubTabNavigationStepper.displayName = 'SubTabNavigationStepper';

export default SubTabNavigationStepper;
